<template>
  <v-dialog v-model="show" persistent max-width="50%">
    <v-card>
      <v-card-text>
        <v-card-title class="headline">
          {{ item.name || item.title }} végleges törlése
        </v-card-title>
        <v-card-text>
          A végleges törlést követően a törölt elem nem állítható vissza!
        </v-card-text>
        <v-card-text>
          Biztosan végrehajtja a műveletet?
        </v-card-text>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="error" @click="deleteModule">
          Igen
        </v-btn>
        <v-btn text color="success" @click="reset">
          Nem
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AlertModal",
  computed: {
    ...mapGetters("Modal", {
      show: "showAlertModal"
    }),
    ...mapGetters("Modal", ["item"])
  },
  methods: {
    ...mapActions("Modal", ["reset", "deleteModule"])
  }
};
</script>
